import { render } from "./Navbar.vue?vue&type=template&id=f1554c32"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import exportComponent from "E:\\RSMentari\\Project RSM\\Portal RSM\\frontend-rsm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__